import { render, staticRenderFns } from "./BrandModal.vue?vue&type=template&id=54cc10b9&scoped=true"
import script from "./BrandModal.vue?vue&type=script&lang=js"
export * from "./BrandModal.vue?vue&type=script&lang=js"
import style0 from "./BrandModal.vue?vue&type=style&index=0&id=54cc10b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cc10b9",
  null
  
)

export default component.exports